<template>
    <div class="text-a-brown-502314">
        <div class="header label text-14 lg:text-base flex items-center py-6 cursor-default" @click="toggle()">
            <div class="flex-auto">
                <span class="font-bold">{{ label }}</span> <span v-if="isOptional"
                    class="text-a-brown-9f8273 text-12 lg:text-14">({{ lblOptional }})</span>
            </div>
            <div class="flex-none">
                <button type="button" class="outline-none appearance-none bg-none">
                    <img class="transform" :class="[active ? 'rotate-180 duration-300' : 'rotate-0 duration-300']"
                        src="@/assets/icon/ic-arrow-down-brown.svg" />
                </button>
            </div>
        </div>
        <div class="pb-6" v-show="active">
            <slot></slot>
        </div>
    </div>
</template>
<script>
import { ref, inject } from 'vue'

export default {
    name: 'Collapsible',
    props: {
        label: {
            type: String,
            default: ""
        },
        isOptional: {
            type: Boolean,
            default: true
        }
    },
    components: {},
    mixins: [],
    emits: [],
    data: function () { return {} },
    computed: {},
    setup: function () {
        const { lbl } = inject("LocaleStore")
        const lblOptional = lbl.value.productDetail.optional
        const active = ref(false)

        const toggle = function () {
            active.value = !active.value
        }

        return {
            active,
            toggle,
            lblOptional
        }
    },
    mounted: function () { },
    methods: {}
}
</script>
